const messages = {
    promoBannerHeader: 'Skill Builder Assistant is here!',
    promoBannerMessage: 'Our AI-powered learner assistant helps you get comprehensive answers, gain deeper knowledge into AWS services, brainstorm effective strategies, and receive tailored training recommendations.',
};
export default messages;
